"use strict";
//#region DevExtreme Imports
Object.defineProperty(exports, "__esModule", { value: true });
//#endregion
var template_1 = require("../../../helpers/template");
exports.SERVICE_NAME = 'imr.controls.components.button.services.button';
var IMRButtonStateService = /** @class */ (function () {
    function IMRButtonStateService() {
    }
    IMRButtonStateService.prototype.isButtonTextOverflowed = function (button) {
        var textWidth = this.getButtonTextWidth(button);
        var buttonWidth = this.getButtonContentWidth(button);
        return Math.floor(textWidth) > Math.floor(buttonWidth);
    };
    IMRButtonStateService.prototype.getButtonTextWidth = function (button) {
        var fontSize = button.element().css('font-size');
        var fontFamily = button.element().css('font-family');
        var textWidth = template_1.getTextWidth(this.getButtonText(button), fontSize, fontFamily);
        return textWidth !== null && textWidth !== void 0 ? textWidth : 0;
    };
    IMRButtonStateService.prototype.getButtonContentWidth = function (button) {
        var _a;
        return (_a = button.element().find('.dx-button-content').width()) !== null && _a !== void 0 ? _a : 0;
    };
    IMRButtonStateService.prototype.getButtonText = function (button) {
        return button.element().find('.dx-button-text').text();
    };
    return IMRButtonStateService;
}());
exports.IMRButtonStateService = IMRButtonStateService;
//# sourceMappingURL=button.service.js.map